// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"87":"237c795c","183":"be9bdc16","298":"5a503894","394":"3acee300","412":"4718e8fd","434":"1b362492","503":"a582115b","726":"18a604b2","741":"2cf14d37"}[chunkId] + ".chunk.css";
};